import { LINE_CLEARANCE_API } from "api/url_helper";

export const PERMISSION_MODULES = {
  ROLE: "Role",
  STUDY: "Study",
  USER: "User",
  WORKFLOW: "Workflow",
  TEMPLATE: "Template",
  DESIGN: "Design",
  CRF: "CRF",
  SUBJECT_CRF: "Subject CRF",
  CRF_QUERY: "CRF Query",
  ALIQUOT: "Aliquot",
  SPONSOR: "Sponsor",
  VOLUNTEER: "Volunteer",
  ADVERSE_EVENT: "Adverse Event",
  TRAINING_GROUP: "Training Group",
  PERIOD: "Period",
  PROTOCOL: "Protocol",
  CODE_LIST: "Codelist",
  ICF: "ICF",
  CHECKLIST: "Checklist",
  STUDY_ATTACHMENT: "Study Attachment",
  IP_INVENTORY: "IP Inventory",
  DISPENSING_LOG: "Dispensing Log",
  RETURNS_LOG: "Returns Log",
  STOCK_RECONCILIATION: "Stock Reconciliation",
  STUDY_SCREENING: "Study Screening",
  DOCUMENT_MANAGEMENT: "Document Management",
  WORKFLOW_QUERY: "Workflow Query",
  DRUG_RETENTION: "Retention",
  DRUG_DISPOSAL: "Disposal",
  DRUG_TRANSFER: "Transfer",
  CLINICAL: "Clinical",
  LABELS: "Labels",
  SESSION: "Session",
  AUDIT_TRAIL: "Audit Trail",
  STUDY_DESIGN: "Study Design",
  PARTICIPANTS: "Participants",
  SUBJECTS: "Subjects",
  TIME_POINT: "Time Point",
  DOSING_SCHEDULE: "Dosing Schedule",
  SUBJECT_CHECKIN: "Subject Check-In",
  SUBJECT_CHECKOUT: "Subject Check-Out",
  SUMMARY_REPORTS: "Summary Reports",
  SUBJECT_LABEL: "Subject Label",
  SUBJECT_ICARD_LABEL: "Subject Icard Label",
  VACUTAINER_LABEL: "Vacutainer Label",
  RIAVIAL_LABEL: "Riavial Label",
  DISPENSING_LABEL: "Dispensing Label",
  GLOBAL_STUDIES: "Global Study Access",
  DASHBOARD: "Dashboard",
  AMBULATORY_VISIT: "Ambulatory Visit",
  BLOCKED_VOLUNTEER: "Blocked Volunteer",
  TRANSFER_VOLUNTEER: "Transfer Volunteer",
  DROPOUT_VOLUNTEER: "Dropout Volunteer",
  SETTINGS: "Settings",
  MODULE_MANAGEMENT: "Module Management",
  LINE_CLEARANCE: "Line Clearance",
  SESSION_PARTICIPANTS: "Session Participants",
  BED_MANAGEMENT: "Bed Management",
  IP_STORAGE: "IP Storage",
  POST_STUDY_ASSESSMENT: "Post Study Assessment",
  DISPATCH: "Dispatch",
  STORAGE: "Storage",
  MANUAL_ENTRY: "Manual Entry",
  SESSION_SUBJECTS: "Session Subjects",
  BOXLABEL: "Box Label",
  ALL_REPORTS: "All Reports",
  SESSION_REPORTS: "Session Reports",
  LABEL_REPORTS: "Label Reports",
  STUDY_REPORTS: "Study Reports",
  USER_ACTIVITY: "User Activity",
  SESSION_DASHBOARD: "Session Dashboard",
} as const;

export const PERMISSION_ACTIONS = {
  VIEW: "VIEW",
  ADD: "ADD",
  EDIT: "EDIT",
  DEACTIVATE: "DEACTIVATE",
  RESPOND: "RESPOND",
  CLOSE: "CLOSE",
  RENAME: "RENAME",
  ASSIGN_RIGHTS: "ASSIGN RIGHTS",
  DOWNLOAD: "DOWNLOAD",
  ADD_VALUES: "ADD VALUE",
  ASSIGN_STUDY: "ASSIGN STUDY",
  VERIFY: "VERIFY",
  ADD_ACTUAL_COUNT: "ADD ACTUAL COUNT",
  EDIT_ACTUAL_COUNT: "EDIT ACTUAL COUNT",
  ASSIGN_TO_MODULE: "ASSIGN TO MODULE",
  ASSIGN_TRAINING_TO_GROUP: "ASSIGN TRAINING TO GROUP",
  STOCK_SUMMARY_REPORT: "STOCK SUMMARY REPORTS",
  STOCK_LEDGER_REPORT: "STOCK LEDGER REPORTS",
  STOCK_EXPIRY_SOON_REPORT: "STOCK EXPIRY SOON REPORTS",
  SUBJECT_WISE_STOCK_REPORT: "SUBJECT WISE STOCK REPORTS",
  EXPORT_CSV: "EXPORT CSV",
  AUDIT: "AUDIT",
  ASSIGN_ROLE: "ASSIGN ROLE",
  SAVE_SCHEDULE: "SAVE SCHEDULE",
  FETCH_LMS_STATUS: "FETCH LMS STATUS",
  SCAN: "SCAN",
  CHECK_IN: "CHECK-IN",
  CHECK_OUT: "CHECK-OUT",
  PRINT: "PRINT",
  FETCH_PRINT_STATUS: "FETCH PRINT STATUS",
  ALCOHOLTEST_ADD:"ALCOHOLTEST-ADD",
  ALCOHOLTEST_EDIT:"ALCOHOLTEST-EDIT",
  ALCOHOLTEST_AUDIT:"ALCOHOLTEST-AUDIT",
  LABTEST_ADD:"LABTEST-ADD",
  LABTEST_EDIT:"LABTEST-EDIT",
  LABTEST_AUDIT:"LABTEST-AUDIT",
  LABTEST_VIEW:"LABTEST-VIEW",
  LABTEST_DOWNLOAD:"LABTEST-DOWNLOAD",
  LABTEST_VERIFY:"LABTEST-VERIFY",
  ICF_ADD:"ICF-ADD",
  ICF_AUDIT:"ICF-AUDIT",
  SCREENING_ADD:"SCREENING-ADD",
  SCREENING_EDIT:"SCREENING-EDIT",
  SCREENING_AUDIT:"SCREENING-AUDIT",
  SCREENING_DEACTIVATE:"SCREENING-DEACTIVATE",
  SCREENING_CRF_ADD:"SCREENING-CRF-ADD",
  DECIDE_SCREENING_RESULT:"DECIDE-SCREENING-RESULT",
  VACUTAINER_TO_ALIQUOT:"VACUTAINER-TO-ALIQUOT",
  SUBJECT_TO_VACUTAINER:"SUBJECT-TO-VACUTAINER",
  ALL_STUDIES:"ALL-STUDIES",
  PARTICIPATION_BASED_STUDIES:"PARTICIPATION-BASED-STUDIES",
  ASSIGN_SUBJECTS:"ASSIGN-SUBJECTS",
  START_VISIT:"START-VISIT",
  COMPLETE_VISIT:"COMPLETE-VISIT",
  PERFORM_ACTIVITIES:"PERFORM-ACTIVITIES",
  BLOCK_SUBJECT:"BLOCK-SUBJECT",
  TRANSFER_VOLUNTEER:"TRANSFER-VOLUNTEER",
  DROPOUT_SUBJECT:"DROPOUT-SUBJECT",
  COMPLETE_STUDY:"COMPLETE-STUDY",
  ARCHIVE_STUDY:"ARCHIVE-STUDY",
  MANAGE_MODULES:"MANAGE-MODULES",
  MANAGE_SETTINGS:"MANAGE-SETTINGS",
  LINE_CLEARANCE_PERFORM:"LINE-CLEARANCE-PERFORM",
  LINE_CLEARANCE_REVIEW:"LINE-CLEARANCE-REVIEW",
  SAMPLE_COLLECTION_TIME_ADD:"SAMPLE-COLLECTION-TIME-ADD",
  SAMPLE_COLLECTION_TIME_EDIT:"SAMPLE-COLLECTION-TIME-EDIT",
  SAMPLE_COLLECTION_TIME_VERIFY:"SAMPLE-COLLECTION-TIME-VERIFY",
  DEVIATION_REASON_ADD:"DEVIATION-REASON-ADD",
  DEVIATION_REASON_EDIT:"DEVIATION-REASON-EDIT",
  DEVIATION_REASON_VERIFY:"DEVIATION-REASON-VERIFY",
  REPLACE:"REPLACE",
  WITHDRAWN:"WITHDRAWN",
} as const;

export const ACTION_DESCRIPTIONS: Record<string, string> = {
  "ALL-STUDIES": "Grants complete access to all clinical studies across the system.",
  "PARTICIPATION-BASED-STUDIES": "Restricts access only to studies where the user is an assigned participant.",
  "VIEW": "Allows viewing records, details, and reports for this module.",
  "ADD": "Allows creating new records for this module.",
  "EDIT": "Allows updating and modifying existing records for this module.",
  "DEACTIVATE": "Allows deactivating records in this module.",
  "VERIFY": "Allows verifying and performing e-signature approvals.",
  "AUDIT": "Allows viewing and downloading detailed audit trails and history logs.",
  "PRINT": "Allows printing for this module.",
  "DOWNLOAD": "Allows downloading files, attachments, or PDF exports.",
  "EXPORT CSV": "Allows exporting module data into CSV file formats.",
  "ASSIGN RIGHTS": "Allows configuring and assigning role-based access rights.",
  "ASSIGN STUDY": "Allows assigning volunteers to clinical studies.",
  "ASSIGN ROLE": "Allows assigning user roles.",
  "CHECK-IN": "Allows performing subject check-in procedures.",
  "CHECK-OUT": "Allows performing subject check-out procedures.",
  "SCAN": "Allows Bio Metrics operations.",
  "BLOCK-SUBJECT": "Allows blocking subjects from study participation.",
  "DROPOUT-SUBJECT": "Allows processing subject dropouts.",
  "TRANSFER-VOLUNTEER": "Allows initiating volunteer transfers.",
  "START-VISIT": "Allows initiating ambulatory visits.",
  "COMPLETE-VISIT": "Allows completing ambulatory visits.",
  "PERFORM-ACTIVITIES": "Allows executing ambulatory visit activities and assessments.",
  "LINE-CLEARANCE-PERFORM": "Allows executing line clearance inspections before dosing.",
  "LINE-CLEARANCE-REVIEW": "Allows reviewing and approving line clearance records.",
  "DECIDE-SCREENING-RESULT": "Allows determining pass/fail eligibility for subject screening.",
  "ASSIGN_SUBJECTS": "Allows assigning subjects for ambulatory visist.",
  "VACUTAINER-TO-ALIQUOT": "Allows processing sample separation from vacutainers to aliquots.",
  "SUBJECT-TO-VACUTAINER": "Allows linking collected blood samples to vacutainers.",
  "MANAGE-MODULES": "Allows enabling or disabling system modules and feature flags.",
  "MANAGE-SETTINGS": "Allows configuring system-wide administrative settings.",
  "COMPLETE-STUDY": "Allows marking a clinical study as fully completed.",
  "ARCHIVE-STUDY": "Allows archiving completed clinical study data.",
  "FETCH LMS STATUS": "Allows retrieving training course progress from LMS.",
  "SAVE SCHEDULE": "Allows configuring and saving Randomization schedules.",
  "RESPOND": "Allows responding to workflow queries.",
  "CLOSE": "Allows closing workflow queries.",
  "RENAME": "Allows renaming records in this module.",
  "ADD VALUE": "Allows adding values to records in this module.",
  "ADD ACTUAL COUNT": "Allows adding actual counts to records in this module.",
  "EDIT ACTUAL COUNT": "Allows editing actual counts in this module.",
  "ASSIGN TO MODULE": "Allows assigning records to modules.",
  "ASSIGN TRAINING TO GROUP": "Allows assigning training to groups.",
  "STOCK SUMMARY REPORTS": "Allows access to stock summary reports.",
  "STOCK LEDGER REPORTS": "Allows access to stock ledger reports.",
  "STOCK EXPIRY SOON REPORTS": "Allows access to stock expiry soon reports.",
  "SUBJECT WISE STOCK REPORTS": "Allows access to subject wise stock reports.",
  "FETCH PRINT STATUS": "Allows fetching print status.",
  "ALCOHOLTEST-ADD": "Allows adding alcohol tests.",
  "ALCOHOLTEST-EDIT": "Allows editing alcohol tests.",
  "ALCOHOLTEST-AUDIT": "Allows viewing audit trail of alcohol tests.",
  "LABTEST-ADD": "Allows adding lab tests.",
  "LABTEST-EDIT": "Allows editing lab tests.",
  "LABTEST-AUDIT": "Allows viewing audit trail of lab tests.",
  "LABTEST-VIEW": "Allows viewing lab tests.",
  "LABTEST-DOWNLOAD": "Allows downloading lab tests.",
  "LABTEST-VERIFY": "Allows verifying lab tests.",
  "ICF-ADD": "Allows adding ICFs.",
  "ICF-AUDIT": "Allows viewing audit trail of ICFs.",
  "SCREENING-ADD": "Allows adding screenings.",
  "SCREENING-EDIT": "Allows editing screenings.",
  "SCREENING-AUDIT": "Allows viewing audit trail of screenings.",
  "SCREENING-DEACTIVATE": "Allows deactivating screenings.",
  "SCREENING-CRF-ADD": "Allows adding CRFs to screenings.",
  "SAMPLE-COLLECTION-TIME-ADD": "Allows bulk adding sample collection times.",
  "SAMPLE-COLLECTION-TIME-EDIT": "Allows editing sample collection time.",
  "SAMPLE-COLLECTION-TIME-VERIFY": "Allows verifying sample collection time.",
  "DEVIATION-REASON-ADD": "Allows adding deviation reason.",
  "DEVIATION-REASON-EDIT": "Allows editing deviation reason.",
  "DEVIATION-REASON-VERIFY": "Allows verifying deviation reason.",
  "REPLACE":"Allows replacing records in this module.",
  "WITHDRAWN":"Allows withdrawing records in this module.",
};

export const getActionDescription = (actionName: string): string => {
  if (!actionName) return "Allows performing operations in this module.";
  const key = actionName.toUpperCase().trim();
  if (ACTION_DESCRIPTIONS[key]) {
    return ACTION_DESCRIPTIONS[key];
  }
  const formatted = key.replace(/[-_]/g, " ").toLowerCase();
  return `Allows user to ${formatted} items in this module.`;
};
